import { useState, useEffect } from "react";
import Header from "../../header/index";
import Footer from "../../footer/index";
import axios from "axios";
import HeaderSubMenuPage from "./headerSubMenu.js";
import {
  downloadFile,
  setAuthorizationToken,
  addBodyClass,
  getCashiHHeight,
} from "../../common/utils";
import { Scrollbars } from "react-custom-scrollbars-2";
import { useAuthenticated } from "react-admin";
import { refreshTokenGen } from "../../../inMemoryJwt.js";
import { array } from "yup";

function InstructionPage() {
  useAuthenticated();
  const [fromError, setfromError] = useState("");
  const [modalImg, setImgUrl] = useState({ title: "", imgUrl: "" });
  const [pagePost, setPostsData] = useState([]);
  const [eleEdition, setEdition] = useState("");
  const [winHeight, setWinHeight] = useState();
  const [calcHeight, setCalcHeight] = useState();
  const [proId, setProId] = useState();
  useEffect(() => {
    function handleResize() {
      let calcHeight = getCashiHHeight();
      let winHeight = window.innerHeight;
      setWinHeight(winHeight);
      setCalcHeight(calcHeight);
    }
    handleResize();
    addBodyClass();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    let urlLocation = window.location.href;
    urlLocation = urlLocation.split("/");
    urlLocation = urlLocation[urlLocation.length - 2];
    setEdition(urlLocation);
    let projectId = localStorage.getItem('projectId');
    setProId(projectId);
    const tokenExpires = localStorage.getItem("tokenexpires");
    let refreshTOk = localStorage.getItem("refresh_token");
    // if(parseInt(tokenExpires) < new Date().getTime()){
    //     refreshTokenGen(refreshTOk).then(challenge => {
    //         if(challenge){
    //             getPosts(urlLocation);
    //         }
    // })
    // } else {
    //     getPosts(urlLocation);
    // }
  }, []);

  return (
    <>
      <Header />
      <div className="breadCrumbSec">
        <div className="container siteContainer">
          <div className="row">
            <div className="col-12">
              <ul className="resetList breadCrumbList">
                <li>
                  <a href="/parts-and-service" className="breadCrumbLink">
                    Parts & Service
                  </a>
                </li>
                <li>
                  <span>Mode d’emploi</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="pageDataSec withoutsubHead">
        <div className="container siteContainer">
          <div className="row">
            <div className="col-8 leftAlignWidth">
              <HeaderSubMenuPage edtionId={eleEdition} proId={proId} />
            </div>
          </div>
          <div className="forumValidationCnt">
            <Scrollbars
              style={{
                height: `calc(${winHeight}px - ${calcHeight}px)`,
                width: "100%",
              }}
              renderscrollbarhorizontal={(props) => (
                <div {...props} className="scrollbar-horizontal" />
              )}
              renderscrollbarvertical={(props) => (
                <div {...props} className="scrollbar-vertical" />
              )}
              renderThumbHorizontal={(props) => (
                <div {...props} className="thumb-horizontal" />
              )}
              renderThumbVertical={(props) => (
                <div {...props} className="thumb-vertical" />
              )}
            >
              <div className="forumValidationCntInner instructionPage">
                <div className="row">
                  <div className="col-12 mb-4">
                    <h1 className="">
                      MODE D’EMPLOI PERSONNALISATION CAMPAGNE AUTOMNE
                    </h1>
                    <p className="">
                      Veuillez consulter attentivement cette notice pour
                      fluidifier la transmission de vos informations.
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-4">
                    <h2 className="">SE CONNECTER</h2>
                    <p className="">
                      À la première connexion, il vous est demandé de vous
                      identifier avec l’identifiant et le mot de passe qui vous
                      a été transmis. Ce sont les mêmes informations que pour
                      personnaliser le Farm Forum.
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-4">
                    <h2 className="">PARCOURS UTILISATEUR</h2>
                    <p className="">
                      Sur l’écran d’accueil, cliquer sur « Hivernage » du menu
                      principal puis sélectionner l'édition que vous souhaitez
                      personnaliser.
                    </p>
                    <p className="">Vous disposez de 3 dossiers :</p>
                    <ol>
                      <li className="">
                        Le dossier « Mode d'emploi » vous permet de consulter le
                        mode d'emploi suivant.
                      </li>
                      <li className="">
                        Le dossier « Personnalisation » est destiné à la
                        personnalisation, en ligne, de votre brochure.
                      </li>
                      <li className="">
                        Le dossier « Commande » dans lequel vous réalisez vos
                        commandes à l'aide des quantités et de votre base de
                        données.
                      </li>
                    </ol>
                    <p className="">
                      <img
                        src="/images/instructionpage/1.jpeg"
                        alt="instructions"
                        className="img-fluid"
                      />
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-4 mt-4">
                    <h2 className="">ÉTAPE 1 : PERSONNALISATION BROCHURE</h2>
                    <p className="">
                      Désormais, c’est directement en ligne que vous pourrez
                      personnaliser votre brochure en cliquant sur le bouton «
                      personnalisation » (1) puis « brochure » (2).
                    </p>
                    <p className="">Suivez les étapes au fur et à mesure :</p>
                    <ul>
                      <li>
                        Première page : entrez vos dates d’opération et le lien
                        url qui renvoie vers votre CNH Store personnalisé
                      </li>
                      <li>
                        Deuxième page : 3 offres à personnaliser (+ QR Code)
                      </li>
                      <li>Troisième page : rien à changer</li>
                      <li>
                        Quatrième page : ajouter votre repiquage (+ QR Code)
                      </li>
                    </ul>
                    <p className="">
                      <img
                        src="/images/instructionpage/2.jpeg"
                        alt="step 1"
                        className="img-fluid"
                      />
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-4 mt-4">
                    <h2 className="">ÉTAPE 2 : PERSONNALISATION COURRIER</h2>
                    <p className="">
                      En cliquant sur le bouton « courrier » (2) (dans l’onglet
                      « personnalisation » (1)), vous pourrez le personnaliser.
                    </p>
                    <p className="">Il vous suffit :</p>
                    <ul>
                      <li>
                        D'entrer vos coordonnées telles qu’elles sont demandées,
                      </li>
                      <li>D’ajouter votre logo,</li>
                      <li>
                        D’ajouter le lien URL vers votre CNH Store personnalisé.
                      </li>
                    </ul>
                    <p className="">
                      Vous pouvez, pour les deux supports, sortir une version
                      basse définition de votre brochure. Une fois validée, la
                      version HD est disponible pour l’Agence, qui l’enverra en
                      impression et en routage.
                    </p>
                    <p className="">
                      <img
                        src="/images/instructionpage/3.jpeg"
                        alt="step 2"
                        className="img-fluid"
                      />
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-4">
                    <h2 className="">ÉTAPE 3 : VOTRE COMMANDE</h2>
                    <p className="mb-2">
                      En cliquant sur « commande » vous validez votre
                      personnalisation de la brochure et du courrier. Attention,
                      pas de retour en arrière possible.
                    </p>
                    <p className="mb-2">
                      Vous y retrouvez la quantité d’exemplaires pris en charge
                      par la marque.
                    </p>
                    <p className="mb-2">
                      À celle-ci, vous pouvez y ajouter des exemplaires
                      supplémentaires, qui eux, seront à votre charge. Si vous
                      souhaitez les envoyer chez vos clients, la quantité
                      d’adresse dans votre base de données doit correspondre à
                      la quantité totale (pris en charge par la marque ET pris
                      en charge par vous-même).
                    </p>
                    <p className="mb-2">
                      Dans le cas contraire, les exemplaires supplémentaires
                      seront envoyés en concession. Vous pouvez les répartir
                      selon vos préférences grâce aux « bases ».
                    </p>
                    <p className="mb-2">
                      Le total de votre commande correspond à ce que vous prenez
                      en charge.
                    </p>
                    <p className="mb-2">
                      L’adresse mail de contact indiquée est celle à qui sera
                      envoyée la notification de la commande.
                    </p>
                    <p className="">
                      En validant cette étape, vous validez votre bon de
                      commande.
                    </p>
                    <p className="">
                      <img
                        src="/images/instructionpage/4.jpeg"
                        alt="step 3"
                        className="img-fluid"
                      />
                    </p>
                  </div>
                </div>
              </div>
            </Scrollbars>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
export default InstructionPage;
